'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _config = require('config/config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThemeHelper = function () {
    function ThemeHelper() {
        (0, _classCallCheck3.default)(this, ThemeHelper);
    }

    (0, _createClass3.default)(ThemeHelper, null, [{
        key: 'getViewForComponent',
        value: function getViewForComponent(componentName) {
            var themeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
                _ref$folderName = _ref.folderName,
                folderName = _ref$folderName === undefined ? null : _ref$folderName;

            var theme = themeName === null ? _config.theme : themeName;
            folderName = folderName || componentName;
            return require('components/' + folderName + '/' + theme + '/' + componentName + 'View');
        }
    }, {
        key: 'getViewForContainer',
        value: function getViewForContainer(containerName) {
            var themeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
                _ref2$folderName = _ref2.folderName,
                folderName = _ref2$folderName === undefined ? null : _ref2$folderName;

            var theme = themeName === null ? _config.theme : themeName;
            folderName = folderName || containerName;
            return require('containers/' + folderName + '/' + theme + '/' + containerName + 'View');
        }
    }, {
        key: 'getThemeName',
        value: function getThemeName() {
            var themeName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            return themeName === null ? _config.theme : themeName;
        }
    }, {
        key: 'includeTheme',
        value: function includeTheme() {
            var themeName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            var theme = themeName === null ? _config.theme : themeName;
            return require('themes/' + theme + '/include');
        }
    }]);
    return ThemeHelper;
}();

exports.default = ThemeHelper;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/theme/ThemeHelper.js
// module id = 113
// module chunks = 0